import React from "react";
import Icon from "@ant-design/icons";
const EditPenOnPaperSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M5.9486 3.73889L4.54235 2.33265C3.93216 1.72245 2.94284 1.72245 2.33264 2.33265C1.72245 2.94284 1.72245 3.93216 2.33264 4.54235L11.1815 13.3912C11.6221 13.8318 12.1655 14.1556 12.7626 14.3335L15 15L14.3335 12.7626C14.1556 12.1655 13.8318 11.6221 13.3912 11.1815L5.9486 3.73889ZM5.9486 3.73889L3.75 5.93749M5 11.6667V15.625C5 16.6605 5.83947 17.5 6.875 17.5H15.625C16.6605 17.5 17.5 16.6605 17.5 15.625V6.87499C17.5 5.83946 16.6605 4.99999 15.625 4.99999H11.6667"
			stroke="#344054"
			// stroke-linecap="round"
			// stroke-linejoin="round"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const EditPenOnPaperIcon = (props) => (
	<Icon component={() => <EditPenOnPaperSvg {...props} />} />
);

export default EditPenOnPaperIcon;
